module.exports = __webpack_public_path__ + "img/hotel.10e62d42.png";